/**
 * Форма обновления данных клиента
 */

import React from 'react';
import { Formik, Form } from 'formik';
import { TextInput } from '../../../components/UI/FormItems';
import { useUpdateClientData } from '../../../hooks/useAdmin';
import { updateClientDataSchema } from '../validation/schemas';
import type { ClientData, UpdateClientDataForm } from '../../../types';

interface UpdateClientDataFormComponentProps {
  clientData: ClientData;
}

/**
 * Компонент формы обновления данных клиента
 */
export const UpdateClientDataFormComponent: React.FC<UpdateClientDataFormComponentProps> = ({
  clientData,
}) => {
  const updateClientMutation = useUpdateClientData();

  const initialValues: UpdateClientDataForm = {
    id: clientData.id,
    firstName: clientData.firstName,
    lastName: clientData.lastName,
    middleName: clientData.middleName,
    birthDate: clientData.birthDate,
    passportSeries: clientData.passportSeries,
    passportNumber: clientData.passportNumber,
    passportIssueDate: clientData.passportIssueDate,
    passportIssueAuthority: clientData.passportIssueAuthority,
    passportIssueLocation: clientData.passportIssueLocation,
    mobilePhone: clientData.mobilePhone,
    email: clientData.email,
  };

  const handleSubmit = async (values: UpdateClientDataForm) => {
    const clientDataToUpdate: ClientData = {
      ...clientData,
      ...values,
    };
    await updateClientMutation.mutateAsync(clientDataToUpdate);
  };

  return (
    <fieldset>
      <Formik
        initialValues={initialValues}
        validationSchema={updateClientDataSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {() => (
          <Form>
            <div className="grid-container">
              <TextInput label="Серия" name="passportSeries" />
              <TextInput label="Фамилия" name="lastName" />

              <TextInput label="Номер" name="passportNumber" />
              <TextInput label="Имя" name="firstName" placeholder="Имя" />

              <TextInput
                label="Дата выдачи"
                name="passportIssueDate"
                placeholder="24/08/2021"
              />
              <TextInput label="Отчество" name="middleName" placeholder="Отчество" />

              <TextInput
                label="Выдавший орган"
                name="passportIssueAuthority"
                placeholder="Выдавший орган"
              />
              <TextInput label="Дата рождения" name="birthDate" placeholder="24/08/2021" />

              <TextInput
                label="Код подразделения"
                name="passportIssueLocation"
                placeholder="Код подразделения"
              />
              <TextInput
                label="Номер телефона"
                name="mobilePhone"
                placeholder="Номер телефона"
              />

              <TextInput label="Эл. почта" name="email" placeholder="email@example.com" />

              <button
                className="btn"
                type="submit"
                disabled={updateClientMutation.isPending}
                style={{ marginLeft: '20px' }}
              >
                {updateClientMutation.isPending ? 'Обновление...' : 'Обновить данные'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </fieldset>
  );
};
